function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "p2dua"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.074 36.986C.074 16.873 16.38.568 36.492.568S72.91 16.873 72.91 36.986 56.605 73.403 36.492 73.403.074 57.1.074 36.986z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.074 36.986C.074 16.873 16.38.568 36.492.568S72.91 16.873 72.91 36.986 56.605 73.403 36.492 73.403.074 57.1.074 36.986z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#5575fa",
  strokeMiterlimit: 20,
  strokeWidth: 6,
  d: "M.074 36.986C.074 16.873 16.38.568 36.492.568S72.91 16.873 72.91 36.986 56.605 73.403 36.492 73.403.074 57.1.074 36.986z",
  clipPath: "url('#p2dua')"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#5575fa",
  d: "M57.294 46.367H15.122V30.022h42.172zM16.232 26.692c.666 0 1.11.444 1.11 1.11 0 .666-.444 1.11-1.11 1.11-.666 0-1.11-.444-1.11-1.11 0-.666.444-1.11 1.11-1.11zm3.329 0c.666 0 1.11.444 1.11 1.11 0 .666-.444 1.11-1.11 1.11-.666 0-1.11-.444-1.11-1.11 0-.666.444-1.11 1.11-1.11zm3.33 0c.665 0 1.11.444 1.11 1.11 0 .666-.445 1.11-1.11 1.11-.667 0-1.11-.444-1.11-1.11 0-.666.443-1.11 1.11-1.11zm-8.879-1.11v21.895h44.391V25.583z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#5575fa",
  d: "M28.44 40.01V38.9h15.536v1.11z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#5575fa",
  d: "M28.44 37.79v-1.11h17.756v1.11z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#5575fa",
  d: "M28.44 35.57v-2.219h9.987v2.22z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#5575fa",
  d: "M28.44 42.23v-1.11h17.756v1.11z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#5575fa",
  d: "M22.335 34.46c.888 0 1.665.778 1.665 1.666 0 .887-.777 1.664-1.665 1.664-.887 0-1.664-.777-1.664-1.664 0-.888.777-1.665 1.664-1.665zm-2.774 6.77zm0-1.22c0-.666.444-1.11 1.11-1.11H24c.665 0 1.109.444 1.109 1.11v1.22c.999-.776 1.665-2.108 1.665-3.44a4.452 4.452 0 0 0-4.44-4.439 4.452 4.452 0 0 0-4.439 4.44c0 1.442.666 2.663 1.665 3.44z"
})));

var SvgWelcomeStep1 = function SvgWelcomeStep1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 74,
    viewBox: "0 0 73 74",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWelcomeStep1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/welcome-step-1.6bf636ad.svg";
export { ForwardRef as ReactComponent };